import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-brand">KAWILA</h3>
            <p className="footer-tagline">Hostel & Coffee</p>
            <p className="footer-description">
              Una experiencia única en Santa Ana, El Salvador. Arquitectura colonial,
              café excepcional y hospitalidad que te hace sentir como en casa.
            </p>
          </div>

          <div className="footer-section">
            <h4>Enlaces Rápidos</h4>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('inicio')}>Inicio</button></li>
              <li><button onClick={() => scrollToSection('sobre-nosotros')}>Sobre Nosotros</button></li>
              <li><button onClick={() => scrollToSection('habitaciones')}>Habitaciones</button></li>
              <li><button onClick={() => scrollToSection('servicios')}>Servicios</button></li>
              <li><button onClick={() => scrollToSection('tours')}>Tours</button></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contacto</h4>
            <ul className="footer-contact">
              <li>
                <span className="footer-icon">📍</span>
                <span>Santa Ana, El Salvador</span>
              </li>
              <li>
                <span className="footer-icon">📧</span>
                <span>info@kawilahostel.com</span>
              </li>
              <li>
                <span className="footer-icon">📱</span>
                <span>+503 XXXX-XXXX</span>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Síguenos</h4>
            <div className="footer-social">
              <a href="#" className="footer-social-icon" title="Facebook">📘</a>
              <a href="#" className="footer-social-icon" title="Instagram">📷</a>
              <a href="#" className="footer-social-icon" title="Twitter">🐦</a>
              <a href="#" className="footer-social-icon" title="TripAdvisor">✈️</a>
            </div>
            <div className="footer-info">
              <p><strong>Check-in:</strong> 2:00 PM</p>
              <p><strong>Check-out:</strong> 12:00 PM</p>
              <p><strong>Recepción:</strong> 24 horas</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} KAWILA HOSTEL & COFFEE. Todos los derechos reservados.</p>
            <p className="footer-made">
              Hecho con dedicación en El Salvador
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
